import { Box, Divider } from "@mui/material";
import { onSnapshot } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useUsuario } from "../../../../providers/usuarioProvider";
import Perfil from "./perfil";
import BusinessDb from "../../../../db/businessDb";
import Business from "../../../../models/business";
import Clientes from "./clientes";
import Usuarios from "./usuarios";

export default function AbaBusiness() {
  const { usuario } = useUsuario();
  const [business, setBusiness] = useState<Business>();

  useEffect(() => {
    if (usuario?.business)
      return onSnapshot(
        new BusinessDb().doc({ businessId: usuario.business }),
        (snapshot) => {
          setBusiness(snapshot.data());
        }
      );
  }, [usuario?.business]);

  if (!business) return <></>;
  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
      <Perfil business={business} />
      <Divider variant="fullWidth" flexItem />
      <Clientes business={business} />
      <Divider variant="fullWidth" flexItem />
      <Usuarios business={business} />
      <Divider variant="fullWidth" flexItem />
    </Box>
  );
}
